<template>
  <div class="userList">
    <div class="page-con-header clearfix">
      <vxe-button type="primary" style="margin-bottom: 10px" @click="addUser"
                  v-if="isHavePermission('user:company:create')">创建企业
      </vxe-button>
      <vxe-button type="primary" style="margin-bottom: 10px" @click="exportCompanyUser"
                  v-if="isHavePermission('user:company:download')">导出企业用户
      </vxe-button>
      <vxe-button icon="vxe-icon--refresh" @click="getList" style="margin-left: 20px; margin-bottom: 10px">刷新
      </vxe-button>
      <div class="search-filter" style="margin-right: 0 !important">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item title="搜索" span="24" :prefix="{ icon: 'fa fa-address-card-o' }"></vxe-form-item>
              <vxe-form-item title="企业名称" field="username" span="12">
                <template v-slot>
                  <Select
                      v-model="searchUserName"
                      clearable
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="(file) => remoteMethod(file,'userNameOptions','baseUserSign','queryUserSignKeyword',1)"
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'userNameOptions')"
                      @on-clear="(file) => remoteMethod(file,'userNameOptions','baseUserSign','queryUserSignKeyword',1)"
                      placeholder="输入客户名称"
                  >
                    <Option
                        v-for="option in userNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="绑定手机号" field="regisiterNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.regisiterNum"
                      placeholder="输入手机号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务员" field="salesManName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSalesManName"
                      clearable
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="(file) => remoteMethod(file,'salesManNameOptions','baseUserSign','queryUserSignKeyword',3)"
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'salesManNameOptions')"
                      @on-clear="(file) => remoteMethod(file,'salesManNameOptions','baseUserSign','queryUserSignKeyword',3)"
                      placeholder="输入业务员"
                  >
                    <Option
                        v-for="option in salesManNameOptions"
                        :value="option.id"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="联系人" field="linkMan" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.linkMan" placeholder="输入联系人"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="联系方式" field="linkPhone" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.linkPhone"
                      placeholder="输入联系方式"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="企业法人" field="realName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.realName"
                      placeholder="输入企业法人"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="营业执照" field="hasBusinessFile" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.hasBusinessFile"
                      :options="hasBusinessFileType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="企业认证状态" field="authStatus" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.authStatus"
                      :options="authStatusType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="认证来源" field="authSource" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.authSource"
                      :options="authSourceType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUser"
                      clearable
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="(file) => remoteMethod(file,'createUserOptions','baseUserSign','queryUserSignKeyword',4)"
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'createUserOptions')"
                      @on-clear="(file) => remoteMethod(file,'createUserOptions','baseUserSign','queryUserSignKeyword',4)"
                      placeholder="输入创建人"
                  >
                    <Option
                        v-for="option in createUserOptions"
                        :value="option.id"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="按创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.createTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button
                      status="primary"
                      icon="ios-search"
                      @click="getSearchListKey"
                      style="border-radius: 5px"
                  >搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px">重置</Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter" style="margin-right: 0 !important">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
    </div>
    <vxe-table
        ref="xTable"
        class="table-style common-shadow"
        stripe
        align="center"
        highlight-current-row
        highlight-hover-row
        :loading="loading"
        :data="compList"
        resizable
        @sort-change="sortChangeEvent"
    >
      <vxe-table-column field="id" title="序号" min-width="100">
        <template slot-scope="{ row }">
          <span>{{ row.id }}</span>
          <Dropdown
              trigger="click"
              style="margin-left: 20px"
              transfer
              v-if="
                  isHavePermission('user:company:auditAuth') ||
                  isHavePermission('user:company:cancelauth') ||
                  isHavePermission('user:company:linkSalesMan') ||
                  isHavePermission('user:company:addLinkComp') ||
                  isHavePermission('user:company:delSalesMan') ||
                  isHavePermission('user:company:changePhone')
                "
          >
            <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
            <DropdownMenu slot="list" style="left: 70px">
              <div style="display: flex; flex-direction: column">
                <Button class="button-gengduo" @click="authUserInfo(row)"
                        v-if="row.authStatus !== 3 && isHavePermission('user:company:auditAuth')">公司认证审核
                </Button>
                <Button class="button-gengduo" @click="cancelauthUserInfo(row)"
                        v-if="row.authStatus === 3 && isHavePermission('user:company:cancelauth')">取消公司认证
                </Button>
                <Button
                    class="button-gengduo"
                    @click="editSalesMan(row)"
                    v-if="row.salesManName == null || (row.salesManName === '' && isHavePermission('user:company:linkSalesMan'))">
                  关联业务员
                </Button>
                <Button class="button-gengduo" @click="addLinkComp(row)"
                        v-if="(!row.aboutCompId || row.aboutCompId === '') && isHavePermission('user:company:addLinkComp')">
                  添加关联企业
                </Button>
                <Button
                    v-if="row.salesManName != null &&row.salesManName !== '' && isHavePermission('user:company:delSalesMan')"
                    class="button-gengduo" style="color: #ed4014" @click="delSalesMan(row)">移除业务员
                </Button>
                <Button class="button-gengduo" @click="showEditFloatData(row)"
                        v-if="isHavePermission('user:company:updateFloatData')">修改浮动数据
                </Button>
                <Button class="button-gengduo" @click="changePhone(row)"
                        v-if="isHavePermission('user:company:changePhone')">修改手机号
                </Button>
                <Button class="button-gengduo" style="color: red" @click="commitDelete(row)"
                        v-if="isHavePermission('user:company:delete')">
                  删除用户
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </vxe-table-column>
      <vxe-table-column field="userName" min-width="140" title="企业名称" show-overflow>
        <template slot-scope="{ row }">
          <span @click="userInfo(row)" style="cursor: pointer; color: #2d8cf0">{{ row.userName }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="regisiterNum" min-width="180" title="绑定手机号" show-overflow></vxe-table-column>
      <vxe-table-column field="taxNum" min-width="180" title="统一社会信用代码" show-overflow></vxe-table-column>
      <vxe-table-column field="realName" min-width="180" title="企业法人" show-overflow></vxe-table-column>
      <vxe-table-column field="regAddr" min-width="180" title="注册地址" show-overflow></vxe-table-column>
      <vxe-table-column field="authStatus" min-width="180" title="认证状态" show-overflow>
        <template slot-scope="{ row }">
          <span style="display: inline-block; margin-left: 10px; cursor: pointer; color: #f59a23"
                @click="auditAuth(row)">{{ authStatus(row) }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="authTime" min-width="180" title="认证时间" show-overflow remote-sort>
        <template slot-scope="{ row }">
          <span style="color: #a7adad">{{ row.authTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="updateUser" min-width="180" title="操作人" show-overflow></vxe-table-column>
      <vxe-table-column field="updateTime" min-width="180" title="操作时间" show-overflow>
        <template slot-scope="{ row }">
          <span style="color: #a7adad">{{ row.updateTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="createUser" min-width="180" title="创建人" show-overflow></vxe-table-column>
      <vxe-table-column field="createTime" min-width="180" title="创建时间" show-overflow>
        <template slot-scope="{ row }">
          <span style="color: #a7adad">{{ row.createTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
        background
        size="small"
        :current-page.sync="current"
        :page-size.sync="pageSize"
        :total="compTotal"
        @page-change="change"
    ></vxe-pager>
    <vxe-modal v-model="editSalesManModal" title="关联业务员" width="800" height="560" resize remember>
      <choose-sales-man ref="chooseSalesMan" @chooseSalesMan="chooseSalesMan"></choose-sales-man>
    </vxe-modal>
    <vxe-modal v-model="linkModal" width="500" height="200" resize remember title="添加关联企业" position="center">
      <link-comp ref="linkComp" @afterSave="afterLink" @close="linkModal = false"></link-comp>
    </vxe-modal>
    <vxe-modal v-model="compAuthVisible" title="企业认证" width="1000" height="800" resize
               position="center">
      <comp-authentication ref="compAuth" @close="compAuthVisible = false"></comp-authentication>
    </vxe-modal>
    <vxe-modal v-model="userInfoModal" width="1450" height="800" position="center" title="查看用户信息" destroy-on-close>
      <user-center :userId="editUserId" :userType="userType" :isUserEdit="false" :userName="userName"
                   :salesManName="salesManName" ref="userCenter" @submitC="submitC"
      ></user-center>
    </vxe-modal>
    <vxe-modal v-model="isShowChangePhone" title="变更手机号" width="500" height="260" position="center" destroy-on-close>
      <change-phone :isComp="true" ref="changePhone" @afterChange="getList"
                    @close="isShowChangePhone = false"></change-phone>
    </vxe-modal>
    <edit-user-monitor-data ref="editUserMonitorData"></edit-user-monitor-data>
  </div>
</template>
<script>
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";
import $C from "@/consts";
import {SEARCH_TIME} from "@/filters/time";
import {hideLoading, isEmpty, postBlob, saveBlob, showLoading} from "@/utils/util";
import moment from "moment";
import Auth from "@/utils/auth";
import ChooseSalesMan from "@/components/modal/ChooseSalesMan";
import LinkComp from "@/components/modal/LinkComp";
import compAuthentication from "@/views/account/compAuthentication";
import UserCenter from "@/views/account/UserCenter";
import ChangePhone from "@/views/newUser/ChangePhone";
import EditUserMonitorData from "@/components/common/EditUserMonitorData";

export default {
  components: {ChooseSalesMan, LinkComp, compAuthentication, UserCenter, ChangePhone, EditUserMonitorData},
  mixins: [getAuthOrization],
  data() {
    return {
      isShowChangePhone: false,
      editSalesManModal: false,
      linkModal: false,
      compAuthVisible: false,
      userInfoModal: false,
      compList: [],
      listQuery: {
        page: 1,
        rows: 10,
        userType: 2,
        userName: null,
        orderBy: 2,
        isDesc: 1,
      },
      searchUserName: null,
      userNameOptions: [],
      searchSalesManName: null,
      salesManNameOptions: [],
      searchCreateUser: null,
      createUserOptions: [],
      searchLoading: false,
      searchVisible: false,
      open: false,
      userId: null,
      userType: null,
      editUserId: 0,
      userName: null,
      salesManName: null,
      searchFormData: {
        username: null,
        salesManName: null,
        compName: null,
        linkMan: null,
        linkPhone: null,
        authStatus: null,
        identityStatus: null,
        createUser: null,
        realName: null,
        time: null,
        userCategory: null,
        hasFile: null,
        regisiterNum: null,
        hasBusinessFile: null,
        authSource: null
      },
      hasBusinessFileType: [
        {
          label: "已上传",
          value: 1,
        },
        {
          label: "未上传",
          value: 0,
        },
      ],
      authStatusType: $C.AUDIT_STATUS.options,
      authSourceType: [{
        label: '平台',
        value: 1
      },
        {
          label: '法大大',
          value: 2
        },
        {
          label: '网易',
          value: 3
        }
      ],
      timeOptions: SEARCH_TIME.options,
      current: 1,
      pageSize: 10,
      compTotal: 50,
      loading: false,
      userCategoryMap: new Map(),
      userCategoryData: {
        options: [],
      },
      userCategoryType: $C.userCategoryTypeTwo.options, // 业务类型选择框
    }
  },
  filters: {
    authStatusRule(val) {
      if (val != null) {
        if (val === 0) {
          return "未认证";
        }
        if (val === 1) {
          return "待审核";
        }
        if (val === 2) {
          return "未通过";
        }
        if (val === 3) {
          return "已认证";
        }
        if (val === 4) {
          return "已失效";
        }
      } else {
        return "未认证";
      }
    },
  },
  watch: {
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
  },
  created() {
    this.$bus.$on("afterCreateCompany", data => {
      if (data) {
        this.getList(this.paramsObj);
      }
    });
  },
  mounted() {
    this.getList();
    this.getDicUserCategoryList();
  },
  methods: {
    sortChangeEvent(sort) {
      if (sort.order == null) {
        this.listQuery.orderBy = 2
        this.listQuery.isDesc = null
      } else {
        this.listQuery.isDesc = sort.order === 'desc' ? 1 : 0
        if (sort.field === 'authTime') {
          this.listQuery.orderBy = 13;
        }
      }
      this.getList();
    },
    commitDelete(row) {
      this.$XModal.confirm("您确定要删除企业用户：" + row.userName + "吗？").then(type => {
        if (type === "confirm") {
          this.deleteUser(row);
        }
      });
    },
    async deleteUser(row) {
      let data = {
        id: row.id,
      };
      showLoading();
      let res = await $api.baseUserSign.request("deleteUser", data);
      hideLoading();
      if (res.status === 1) {
        this.getList();
        this.$XModal.message({message: `操作成功！`});
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    showEditFloatData(row) {
      this.$refs.editUserMonitorData.init(row.id);
    },
    changePhone(row) {
      this.isShowChangePhone = true;
      this.$nextTick(() => {
        this.$refs.changePhone.setUpdate(row);
      })
    },
    authStatus(row) {
      let val = row.authStatus;
      if (val != null) {
        if (val === 0) {
          return "未认证";
        }
        if (val === 1) {
          return "待审核";
        }
        if (val === 2) {
          return "未通过";
        }
        if (val === 3) {
          if (row.authSource === 1) {
            return "已认证(平台)";
          } else if (row.authSource === 2) {
            return "已认证(法大大)";
          } else if (row.authSource === 3) {
            return "已认证(网易)";
          } else {
            return "已认证";
          }
        }
        if (val === 4) {
          return "已失效";
        }
      } else {
        return "未认证";
      }
    },
    submitC(val) {
      if (val) {
        this.getList();
      }
    },
    reset() {
      this.searchUserName = null;
      this.searchSalesManName = null;
      this.searchCreateUser = null;
      this.searchFormData = {
        username: null,
        salesManName: null,
        compName: null,
        linkMan: null,
        linkPhone: null,
        authStatus: null,
        identityStatus: null,
        createUser: null,
        realName: null,
        time: null,
        userCategory: null,
        hasFile: null,
        regisiterNum: null,
        hasBusinessFile: null,
        authSource: null
      };
      this.listQuery = {
        page: 1,
        rows: 10,
        userType: 2,
        userName: null,
        orderBy: 2,
        isDesc: 1,
      };
      this.$refs.xTable.clearSort();
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getSearchList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getSearchList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
        moduleType: 2
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    change(val) {
      this.listQuery.page = val.currentPage;
      this.listQuery.rows = val.pageSize;
      this.getList();
    },
    getDicUserCategoryList() {
      var self = this;
      $api.other.getDicUserCategoryTwoModel
          .GET({
            params: {
              page: 1,
              rows: 10,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              let obj = {
                label: item.dictText,
                value: item.dictCode,
              };
              self.userCategoryData.options.push(obj);
              self.userCategoryMap.set(item.dictCode, item.dictText);
            });
            self.userCategoryType = JSON.parse(JSON.stringify(self.userCategoryData.options));
          });
    },
    getList() {
      this.loading = true;
      let data = this.listQuery;
      $api.gcdUser.queryGcdUserListModel.POST({data}).then((response) => {
        if (parseInt(response.status) === 1) {
          let res = response.data;
          res.rows.map(i => {
            i.showUserCategory = this.userCategoryMap.get(i.userCategory);
          })
          this.compList = res.rows;
          this.compTotal = res.total;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: response.message ? response.message : "接口异常",
            status: "error",
          });
        }
      })
          .catch((error) => {
            console.log(error);
          });
    },
    async exportCompanyUser() {
      if (isEmpty(this.compList)) {
        this.$XModal.message("暂无数据");
        return;
      }
      showLoading();
      let res = postBlob("/api/admin/baseUserSign/exportCompanyUser", this.listQuery);
      hideLoading();
      await saveBlob("导出企业用户列表.xls", res.data);
    },
    getSearchListKey() {
      let obj = this.searchFormData;
      let paramsObj = Object.assign({}, this.listQuery);
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && key !== "createTime") {
          paramsObj[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          paramsObj.beginDate = moment(obj.createTime[0]).valueOf(); // 开始时间
          paramsObj.endDate = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
      });
      if (this.searchUserName) {
        paramsObj.username = this.searchUserName;
      }
      if (this.searchSalesManName) {
        paramsObj.salesManId = this.searchSalesManName;
      }
      if (this.searchCreateUser) {
        paramsObj.createUserId = this.searchCreateUser;
      }
      paramsObj.page = 1;
      this.current = 1;
      paramsObj.userType = 2;
      paramsObj.rows = this.pageSize;
      this.listQuery = paramsObj;
      this.getList();
      this.searchVisible = false;
    },
    userInfo(row) {
      this.userType = row.userType;
      this.salesManName = row.salesManName;
      this.editUserId = row.id;
      this.userInfoModal = true;
      this.userName = row.compName;
    },
    authUserInfo(row) {
      this.$XModal.confirm("该操作将把该用户变为认证状态").then((type) => {
        if (type === "confirm") {
          this.commitAuthUser(row);
        }
      });
    },
    async commitAuthUser(row) {
      var self = this;
      var data = {
        id: row.id,
      };
      new Promise((resolve, reject) => {
        $api.gcdUser.queryGcdUserModel
            .POST({
              data,
            })
            .then((response) => {
              if (response.data.userCategory === 4) {
                if (response.data.transportLicenseUrl == null ||
                    response.data.transportLicenseUrl === "") {
                  this.$XModal.alert({
                    message: "资料不全，请先上传认证资料",
                    status: "error",
                  });
                  return;
                }
              }
              if (response.data.businessUrl === null ||
                  response.data.businessUrl === "" ||
                  response.data.compName === null ||
                  response.data.taxNum === null) {
                this.$XModal.alert({
                  message: "资料不全，请先上传认证资料",
                  status: "error",
                });
                return;
              }
              let param = {
                auditUserId: parseInt(Auth.getAuth().id),
                auditStatus: 3,
                userId: row.id,
              };

              this.commitauth(param);
              self.$forceUpdate();
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    async commitauth(formData) {
      let self = this;
      let res = await $api.authUser.request("auditAuth", formData);
      if (res.status === 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "认证成功",
        });
        self.editSalesManModal = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cancelauthUserInfo(row) {
      this.$XModal.confirm("该操作将取消用户认证").then((type) => {
        if (type === "confirm") {
          this.commitCancelAuthUser(row);
        }
      });
    },
    async commitCancelAuthUser(row) {
      let self = this;
      let param = {
        userId: row.id,
        remark: "您的认证已失效",
      };
      let res = await $api.authUser.request("cancelAuth", param);
      if (res.status == 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "操作成功",
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    editSalesMan(row) {
      this.editSalesManModal = true;
      this.$refs.chooseSalesMan.init();
      this.userId = row.id;
    },
    async chooseSalesMan(val) {
      let data = {
        id: this.userId,
        salesManId: val.id,
      };
      let res = await $api.baseUserSign.post("updateSignUserSaleMan", data);
      if (res.status === 1) {
        this.getList();
        this.$XModal.message({message: `关联成功！`});
        this.editSalesManModal = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    addLinkComp(row) {
      this.linkModal = true;
      this.$refs.linkComp.init(row);
    },
    delSalesMan(row) {
      this.$XModal.confirm("您确定要移除业务员吗？").then((type) => {
        if (type === "confirm") {
          this.commitDelSalesMan(row);
        }
      });
    },
    async commitDelSalesMan(row) {
      let data = {
        id: row.id,
        salesManId: 0,
      };
      let res = await $api.baseUserSign.post("updateSignUserSaleMan", data);
      if (parseInt(res.status) === 1) {
        this.getList();
        this.$Message["success"]({
          background: true,
          content: "移除成功",
        });
        this.editSalesManModal = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    auditAuth(row) {
      //认证状态0.未认证 1.已提交/待审核 2.未通过 3.通过 4.已过期',
      this.compAuthVisible = true;
      this.$nextTick(() => {
        this.$refs.compAuth.init(row.id);
      })
    },
    afterLink() {
      this.linkModal = false;
      this.getList();
    },
    addUser() {
      let obj = {
        name: `新建企业客户`,
        path: `/newUser/createCompany`
      };
      // this.$store.dispatch("tagsView/addVisitedView", obj);
      // this.$router.push(obj.path);
      window.open(obj.path);
    },
  }
}
</script>
<style>
.userList .ivu-card-shadow {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}

.userList .vxe-table th .vxe-cell {
  color: rgb(128, 134, 149);
  font-weight: 400;
}

.pageCss {
  display: flex;
  margin: 10px;
  flex-direction: row-reverse;
}

.userList .ivu-card-body {
  padding: 1px;
}

.userList .ivu-table-wrapper-with-border {
  border: 0px solid #dcdee2;
  border-bottom: 0;
  border-right: 0;
}

.userList .ivu-table-border:after {
  content: "";
  width: 0px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: #dcdee2;
  z-index: 3;
}

.infoPaddingCss .vxe-cell--title .ivu-btn-icon-only,
.infoPaddingCss .vxe-cell .ivu-btn-icon-only {
  width: 20px;
  height: 20px;
  padding: 0;
  font-size: 12px;
  /* border-radius: 4px; */
}

.fontWeight {
  font-weight: 800;
  margin-bottom: 10px;
  display: inline-block;
}

.vxe-form .infoPaddingCss .vxe-form--item {
  display: none;
  padding: 0em 0.8em 0.5em 0;
}

.infoPaddingCss .vxe-input:not(.is--disabled).is--active .vxe-input--inner {
  border: 0px solid #409eff;
}

.infoPaddingCss .vxe-form--item-title {
  padding-left: 10px;
  padding-right: 0em;
}

.infoPaddingCss .vxe-input--inner {
  width: 100%;
  height: 100%;
  /* border-radius: 4px; */
  outline: 0;
  padding: 0 0.6em;
  color: #606266;
  border: 0px solid #dcdfe6;
  background-color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.upload-list2-wrap {
  display: flex;
  flex-wrap: wrap;
}

.upload-list2 {
  display: inline-block;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-left: 4px;
  vertical-align: middle;
  margin-bottom: 10px;
}

.upload-list2 img {
  width: 100%;
  height: 100%;
  border-style: none;
}

.add-box .file-upload-box2 {
  height: 100px;
  width: 100px;
  line-height: 100px;
  border: 1px dashed #dcdee2;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}

.upload-list2:hover .upload-list2-cover {
  display: block;
}

.upload-list2-cover {
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
}

.upload-list2-cover i {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin: 0 auto;
  text-indent: 0;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 20px;
}

.upload-list2 .pdf-box2 {
  height: 100px;
  width: 100px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}

/* .flexCss {
      display: flex;
      justify-content: center;
    } */
</style>